'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2c1.8 3.4 5.7 5 9.4 3.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1c-1.1 3.7 .5 7.6 3.9 9.4C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2c-3.4 1.8-5 5.8-3.9 9.4c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1c-3.7-1.1-7.6 .5-9.4 3.9C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2c-1.8-3.4-5.7-5-9.4-3.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1c1.1-3.7-.5-7.6-3.9-9.4C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2c3.4-1.8 5-5.7 3.9-9.4c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1c3.7 1.1 7.6-.5 9.4-3.9zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-61.9-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;